/**
 * @file
 * Absence Modal handler - loads URL into iframe when modal opens.
 */
(function () {
  'use strict';

  var modal = document.getElementById('absenceModal');
  if (!modal) {
    return;
  }

  var label = document.getElementById('absenceModalLabel');
  var iframe = document.getElementById('absenceModalIframe');
  if (!label || !iframe) {
    return;
  }

  function syncIframeModalState() {
    try {
      var iframeDocument = iframe.contentDocument;
      if (!iframeDocument || !iframeDocument.body) {
        return;
      }

      iframeDocument.documentElement.classList.add('modal-page');
      iframeDocument.body.classList.add('modal-page');
    }
    catch (error) {
      // Ignore iframe access errors and leave the page unmodified.
    }
  }

  var defaultTitle = label.textContent;

  iframe.addEventListener('load', syncIframeModalState);

  modal.addEventListener('show.bs.modal', function (event) {
    var trigger = event.relatedTarget;
    var url = trigger ? trigger.getAttribute('data-modal-url') : '';
    var title = trigger ? trigger.getAttribute('data-modal-title') : '';

    label.textContent = title || defaultTitle;
    iframe.src = url || '';
  });

  modal.addEventListener('hidden.bs.modal', function () {
    iframe.src = '';
  });

})();
